package de.xtl.retroguide

import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.platform.Font
import org.jetbrains.compose.resources.ExperimentalResourceApi
import retroguide.app.shared.generated.resources.Res

@OptIn(ExperimentalResourceApi::class)
internal actual suspend fun FontFamily.Resolver.preloadEmojiFallback() {
    val bytes = Res.readBytes("font/noto_colrv1_noflags.ttf")
    preload(FontFamily(Font("NotoColorEmoji", bytes)))
}
